import React, { useEffect, useState } from "react";
import "./CreateSurvey.scss";
import SurveyTemplates from "./SurveyTemplates";
import ParticipantCriteria from "./ParticipantCriteria";
import CustomizeQuestion from "./customizeQuestion/CustomizeQuestionIndex";
import { useSearchParams } from "react-router-dom";
import {
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import StructurePreview from "./structurePreview/StructurePreview";
import PublishSurvey from "./publishSurvey/PublishSurvey";
import { getTemplateListAPI } from "services/survey";
import { getFromLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import { useTranslation } from "react-i18next";

const CreateSurvey = () => {
  // Set all value

  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  const stepperValue = Number(getParamsData?.stepper) || 1;
  const selectedSurveyId = getParamsData?.surveySlug || "";
  const steps = [
    { step: 1, label: "Choose a Template", component: <SurveyTemplates /> },
    {
      step: 2,
      label: t("CREATE_SURVEY.chooseTemplate"),
      component: <ParticipantCriteria />,
    },
    {
      step: 3,
      label: t("CREATE_SURVEY.customizeQuestion"),
      component: <CustomizeQuestion />,
    },
    {
      step: 4,
      label: t("CREATE_SURVEY.participantCriteriaPreview"),
      component: <StructurePreview />,
    },
    {
      step: 5,
      label: t("CREATE_SURVEY.shareSurvey"),
      component: <PublishSurvey />,
    },
  ];

  //---------------------------- function -------------------------//

  // Stepper Value handler function
  // const stepperValueHandler = (value) => {
  //   const paramsData = {
  //     surveySlug: selectedSurveyId,
  //     stepper: value,
  //   };
  //   const encryptedParams = handleEncryptionParams(paramsData, searchParams);
  //   setSearchParams(encryptedParams);
  // };

  useEffect(() => {
    if (stepperValue !== 1) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [stepperValue]);

  //************************* Handle  **********************//
  return (
    <>
      <div className="create_survey">
        <div className="survey_step">
          <ul>
            {steps.map(({ step, label }, index) => {
              return (
                stepperValue > 1 &&
                step - 1 > 0 && (
                  <li
                    disabled
                    key={`${label}-${step}-${index}`}
                    // onClick={
                    //   stepperValue >= step
                    //     ? () => stepperValueHandler(step)
                    //     : undefined
                    // }
                    className={stepperValue >= step ? "active" : ""}
                  >
                    <span className="count">{step - 1}</span>
                    <span className="text">{label}</span>
                  </li>
                )
              );
            })}
          </ul>
        </div>

        <div className="survey_content_wrap">
          {steps.map(
            ({ step, component }, index) =>
              stepperValue === step && (
                <div key={`${step}-${index}`}>{component}</div>
              )
          )}
        </div>
      </div>
    </>
  );
};

export default CreateSurvey;
